<template>
  <div>
    <div class="Main_aside">
      <MainMenu ref="mainmenu" :menuList="menuList" :menuEventName="menuEventName" @getMenuClick="getMenuClick" />
    </div>
    <div class="Main_main">
      <div class="Main_top">
        <div style="float: right;margin-right: 20px;">
          <Buttom ref="buttom" :buttomObject="buttomObject" @getSaveUser="getButtomClick_out"></Buttom>
        </div>
      </div>
      <MainTab ref="maintab" :tabValue="tabValue" :tabList="tabList" :tabRemoveEventName="tabRemoveEventName" @getMenuRemoveClick="getMenuRemoveClick" />
    </div>
  </div>
</template>

<script>
  import MainMenu from '@/components/MainMenu/index.vue'
  import MainTab from '@/components/MainTab/index.vue'
  import Buttom from '@/components/Buttom/index.vue'
  export default {
    name: 'adminmain',
    data(){
      return {
        menuList:[
          /*{"name":"客户管理","child":[
            {
              "name":"客户分类","router":"/class"
            },
            {
              "name":"创建客户","router":"/addUser"
            },
            {
              "name":"客户管理","router":"/userManage"
            }
          ]},
          {"name":"数据统计","child":[
            {
              "name":"监测看版","router":"/dataKanban"
            },
            {
              "name":"客户统计数据","router":"/purchaser"
            },
            {
              "name":"按日统计数据","router":"/dayData"
            },
            {
              "name":"同步运行查询","router":"/synchronization"
            }
          ]},
          {"name":"系统设置","child":[
            {
              "name":"白名单","router":"/whiteList"
            },
            {
              "name":"菜单管理","router":"/menu"
            }
          ]}*/
        ],
        tabValue: '',
        tabList:[],
        menuEventName:"getMenuClick", //菜单点击事件
        tabRemoveEventName:"getMenuRemoveClick",
        buttomObject:{
          type:"danger",
          round:true,
          buttomEventName:"getSaveUser",
          icon:"",
          size:"medium",
          label:"退出"
        }
      }
    },
    components: {
      MainMenu,
      MainTab,
      Buttom
    },
    methods:{
      getMenuClick:function (targetName,tabIndex) {
        let newTabName = tabIndex;
        if(!this.isCF(this.tabList,newTabName)){
          this.tabList.push({
            title: targetName,
            name: newTabName
          });
          this.tabValue = newTabName;
        }else{
          this.tabValue = newTabName;
        }
      },
      isCF:function (arr,val) {
        var b = false;
        arr.forEach(item=>{
          if(item.name==val){
            b = true;
          }
        });
        return b;
      },
      getMenuRemoveClick:function (targetName) {
        let tabs = this.tabList;
        let activeName = this.tabValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        this.tabValue = activeName;
        this.tabList = tabs.filter(tab => tab.name !== targetName);
      },
      checkLogin:async function () {
        await this.$axios.post('/root/checkLogin',{

        }).then((response,err) => {
          if(!err){
            response = response.data;
            if(response.code == "Login"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
              this.$router.push({path:'/login'})
            }
          }
        });
      },
      delCookie(name) {
        function getCookie(name) {
          var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
          if (arr = document.cookie.match(reg))
            return (arr[2]);
          else
            return null;
        }
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = getCookie(name);
        if (cval != null)
          document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
      },
      getButtomClick_out:function (val) {
        this.delCookie("dataPlatformID");
        this.$router.push({path:'/login'})
      },
      getMenu:async function () {
        await this.$axios.post('/data/getMenu',{}).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.menuList = response.data;

          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      }
    },
    mounted(){
      //this.checkLogin();
      this.getMenu();
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
  }
  .Main_aside {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 230px;
    bottom: 0px;
    border-right: solid 1px #e6e6e6;
    background-color: #545c64;
  }
  .Main_main {
    position: absolute;
    top: 0px;
    left: 230px;
    right: 0px;
    bottom: 0px;
    overflow: hidden;
  }
  .Main_top {
    padding: 0;
    margin: 0;
    height: 50px;
    line-height: 50px;
    background-color: #ffffff;
    color: white;
    border-bottom: solid 2px #545c64;
  }
  .Main_aside{
    overflow-x: hidden;overflow-y: auto
  }
  .Main_aside::-webkit-scrollbar {/*滚动条整体样式*/

    width: 7px;     /*高宽分别对应横竖滚动条的尺寸*/

    height: 1px;

  }
  .Main_aside::-webkit-scrollbar-thumb {/*滚动条里面小方块*/

    border-radius: 7px;

    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);

    background: #535353;

  }

  .Main_aside::-webkit-scrollbar-track {/*滚动条里面轨道*/

    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);

    border-radius: 7px;

    background: #EDEDED;

  }
  .Main_aside el-menu {
    margin: 0px !important;
    border-right: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/index.vue